export default __webpack_public_path__ + "static/media/welcome.31e5de21.svg";